export default "__VITE_ASSET__5d299972__"